import { FooterModule } from './components/footer/footer.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccordionModule } from './ui-components/accordion/accordion.module';
import { ButtonModule } from './ui-components/buttons/button.module';
import { CardPrimaryModule } from './ui-components/card-primary/card-primary.module';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { VoucherCardSecondaryModule } from './ui-components/voucher-card-secondary/voucher-card-secondary.module';
import { OfferCardModule } from './ui-components/offer-card/offer-card.module';
import { VoucherCardModule } from './ui-components/voucher-card/voucher-card.module';
import { LinkModule } from './ui-components/link/link.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './services/token.interceptor';
import { HeaderModule } from './components/header/header.module';
import { SearchWidgetModule } from './ui-components/search-widget/search-widget.module';
import { ErrorInterceptor } from './services/error.interceptor';
import { MatDialogModule } from '@angular/material/dialog';
import { ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

@NgModule({
  declarations: [AppComponent],
  imports: [
    HeaderModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ButtonModule,
    CardPrimaryModule,
    AccordionModule,
    VoucherCardSecondaryModule,
    ToastrModule.forRoot({
      closeButton: true,
      preventDuplicates: true,
    }),
    OfferCardModule,
    VoucherCardModule,
    LinkModule,
    HttpClientModule,
    SearchWidgetModule,
    // BannerModule
    FooterModule,
    MatDialogModule,
  ],

  providers: [
    ToastrService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
